import React from 'react';
import styles from './component-toolbar-layout.scss';
import { Text } from '@wix/design-system';

interface Props {
  label?: React.ReactNode;
  actions: React.ReactNodeArray;
  children: React.ReactNode;
}

export const ComponentToolbarLayout: React.FunctionComponent<Props> = ({
  label,
  children,
  actions,
}: Props) => (
  <div className={styles.componentToolbarLayout}>
    <div className={styles.toolbar}>
      <Text size="small">{label}</Text>

      <ul className={styles.actions}>
        {React.Children.map(actions, (child, index) => (
          <li key={index} className={styles.action}>
            {child}
          </li>
        ))}
      </ul>
    </div>

    {children}
  </div>
);
